import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { PatientService } from '../../../pages/definition/patient/services/patient.service';
import { ParameterService } from '../../services/parameter/parameter.service';
import { MedicalAdviceService } from './services/medical-advice.service';
import { AppMessageService } from '../../services/app-message/app-message.service';
import { TranslateService } from '@ngx-translate/core';
import { PatientCardComponent } from '../patient-card/patient-card.component';
import { PatientCreateComponent } from '../../../pages/definition/patient/patient-create/patient-create.component';
import { IPatient } from '../../../pages/definition/patient/interface/patient.interface';

@Component({
  selector: 'core-medical-advice-dialog',
  templateUrl: './medical-advice.component.html',
  styleUrls: ['./medical-advice.component.scss'],
})
export class MedicalAdviceComponent implements OnInit{
  medicalAdviceForm: FormGroup;
  visible: boolean = false;
  callReasons: any[] = [];
  patientList: any[] = [];
  isSubmit: boolean = false;
  lockInput: boolean = false;
  @ViewChild('patientCard') patientCard: PatientCardComponent;
  @ViewChild('createPatient') createForm: PatientCreateComponent;
  @Output() saveOn = new EventEmitter();
  @Output() updateOn = new EventEmitter();
  showDialog: boolean = false;
  updatedId: number | null = null;
  selectedPatient:IPatient | null=null;
  constructor(
    private readonly fb: FormBuilder,
    private readonly patientService: PatientService,
    private readonly parameterService: ParameterService,
    private readonly medicalAdviceService: MedicalAdviceService,
    private readonly messageService: AppMessageService,
    private readonly translate: TranslateService
  ) {




  }

  ngOnInit() {

    this.medicalAdviceForm = this.fb.group({
      callPhone: new FormControl('', [Validators.required]),
      // callNameSurname: new FormControl('', [Validators.required]),
      personFullName: new FormControl('', [Validators.required]),
      personNo: new FormControl(null),
      callReason: new FormControl('', [Validators.required]),
      complaint: new FormControl('', [Validators.required]),
      userNote: new FormControl(''),
    });

    this.patientService.getFilter({}, {}).subscribe((res) => {
      this.patientList = res?.items?.map((data: any) => {
        return {
          label: data?.id + '-' + data.firstName + ' ' + data?.lastName,
          value: data.id,
        };
      });
    });


  }

  resetForm() {
    this.isSubmit = false;
    this.visible = false;
    this.updatedId = null;
    this.medicalAdviceForm.setValue({
      callPhone: '',
      // callNameSurname: '',
      personFullName: '',
      personNo: null,
      callReason: '',
      complaint: '',
      userNote: '',
    });

    this.patientCard.resetSelectedPatient();
  }
  saveMedicalAdvice() {
    this.isSubmit = true;

    // Mark all controls as touched to show validation errors
    this.medicalAdviceForm.markAllAsTouched();

    if (this.medicalAdviceForm.invalid) return;

    // handle saving the form data
    this.medicalAdviceService
      .create({
        ...this.medicalAdviceForm.getRawValue(),
        userNote: this?.medicalAdviceForm.value.userNote ?? '',
      })
      .subscribe((res) => {
        this.messageService.successToast(
          this.translate.instant('common.success'),
          this.translate.instant('common.saveSuccessToastMessage')
        );
        this.resetForm();
        this.saveOn.emit(res);
      });
  }

  updateMedicalAdvice() {
    this.medicalAdviceService
      .update({
        id: this.updatedId,
        ...this.medicalAdviceForm.value,
      })
      .subscribe((res) => {
        this.messageService.successToast(
          this.translate.instant('common.success'),
          this.translate.instant('common.updateSuccessToastMessage')
        );
        this.updateOn.emit(res);
        this.resetForm();
      });
  }

  onOpenDetail(patientDetail: any) {
    this.showDialog = true;
    setTimeout(() => {
      this.createForm.initialize(patientDetail);
    }, 500);
  }
  onPatientSelect(patient: any) {
    this.medicalAdviceForm.get('personFullName')?.enable();
    this.lockInput = false;
    if (patient === null) {
      this.medicalAdviceForm.patchValue({
        personFullName: '',
        personNo: null,
      });
    }
    if (patient?.firstName && patient?.lastName) {
      this.lockInput = true;
      this.medicalAdviceForm.patchValue({
        personFullName: `${patient.firstName} ${patient.lastName}`,
        personNo: patient?.id,
      });
      this.medicalAdviceForm.get('personFullName')?.disable();
    }
  }

  initilize(data?: any) {

this.openDialog();
    if (data) {
      this.updatedId = data?.id;
      this.medicalAdviceForm.patchValue({
        ...data,
        callReason: data?.callReason?.id,
        personFullName: data?.personNo
          ? `${data.personNo.firstName} ${data.personNo.lastName}`
          : data?.personFullName,
        personNo: data?.personNo?.id,
      })

      if(data?.personNo){
        this.patientCard.setPatientValue(data?.personNo?.id)
      }
    } else {
      this.updatedId = null;
      this.medicalAdviceForm.reset();
      const defaultReason = this.callReasons?.find(c => c.isDefault);
      if (defaultReason) {
        this.medicalAdviceForm.patchValue({
          callReason: defaultReason.value
        });
      }
    }
    this.visible = true;
  }

  openDialog() {
    this.parameterService
      .getParameterValues('data-group', 'medicalAdviceCallReasons')
      .subscribe((res) => {
        this.callReasons = res?.datas?.values.map((data: any) => {

          if (data.valueObject.default?.value == true){
            this.medicalAdviceForm.patchValue({
              callReason: data?.id
            });
          }
          return {
            label: data.valueObject.name.value,
            value: data?.id,
            isDefault: data.valueObject.default?.value == true
          };
        });
      });
    this.visible = true;
  }

  onNumberInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    inputElement.value = inputElement.value.replaceAll(/\D/g, '');
  }


  onlyNumber(event: KeyboardEvent): boolean {
    const char = event.key;

    if (!/[0-9.,]/.test(char)) {
      event.preventDefault();
      return false;
    }

    return true;
  }


  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const clipboardData = event.clipboardData?.getData('text');
    if (clipboardData && /^\d+$/.test(clipboardData)) {
      (event.target as HTMLInputElement).value = clipboardData;
    }
  }
  onStringInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    // Sadece harfleri ve boşluğu kabul et
    inputElement.value = inputElement.value.replaceAll(
      /[^a-zA-ZğüşöçıİĞÜŞÖÇ ]/g,
      ''
    );
  }
}
